jQuery(function($) {

    const columnsArgs = {
        dots: false,
        arrows: false,
        slidesToShow: 1,
        infinite: true,
        slidesToScroll: 1,
        centerMode: true
    };
    
    let windowWidth  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if(windowWidth < 768) {
        $('.d6-block--columns .d6-block--columns-inner:not(.d6-block--columns--no-slickslider .d6-block--columns-inner)').slick(columnsArgs);
    }
});